/**
 * Created by jonas on 2021-02-02.
 */
import {GameModel} from "@nolimitcity/slot-game/bin/model/GameModel";
import {
    TheCageGameData,
    TheCageInitData,
    isTheCageGameData,
    SymbolValues,
    WinData,
    WinLineData
} from "./TheCageData";
import {ApiPlugin} from "@nolimitcity/slot-launcher/bin/plugins/ApiPlugin";
import {StateMatrix} from "../utils/StateMatrix";
import {TheCageSymbolStates} from "../reels/TheCageSymbol";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {TheCage} from "../TheCage";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {KillBadgeData} from "../view/TheCageTransitionScreenView";
import {TheCageGameMode} from "./TheCageGameMode";


export class TheCageModel extends GameModel<TheCageInitData, TheCageGameData> {
    public winMatrix:StateMatrix<TheCageSymbolStates>;

    public isRestore:boolean = false;
    public visibleReelMatrix:StateMatrix<string>;
    public evaluatedArea:StateMatrix<string>;
    public winData:WinData;
    public isRestoreFeatureBet:boolean;
    public buyFeatureName:string;
    public winCapReached:boolean = false; //TODO make this real
    public symbolValues?:SymbolValues;
    public totalWays:{
        start:number;
        afterXBomb:number;
    };

    public hasWonFsClient:boolean = false;

    constructor(api:ApiPlugin, triggerEvents:boolean = true) {
        super(api, triggerEvents);

        api.events.once("featureBet", (data:boolean) => {
            this.isRestoreFeatureBet = data;
        });
        api.events.once("featureName", (data:string) => {
            this.buyFeatureName = data;
        });
        TheCage.apiPlugin.events.on(APIEvent.BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < TheCage.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCage.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });
        TheCage.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData:APIFeatureBetEventData) => {
            for (let index = 0; index < TheCage.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheCage.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                    this.buyFeatureName = betData.featureName;
                    Logger.logDev("Opted Feature : ", this.buyFeatureName);
                    break;
                }
            }
        });

    }

    protected onInit(data:TheCageInitData):void {
        console.log("INIT DATA", data);
        super.onInit(data);
        this.symbolValues = data.symbolValues;
        this.isRestore = data.isRestoreState;
    }

    public onGame(data:TheCageGameData):void {
        // console.log("GAME DATA", data);
        super.onGame(data);
        this.isRestore = false;
        this.evaluatedArea = new StateMatrix<string>(data.evaluatedArea);
        this.visibleReelMatrix = new StateMatrix<string>(data.reels);
        if (this.data.mode == TheCageGameMode.FREESPIN || this.data.mode == TheCageGameMode.FREESPIN_AVALANCHE) {
            this.winData = this.createFreeSpinWinData(data, this.visibleReelMatrix, this.evaluatedArea)
        } else {
            this.winData = this.createWinData(data, this.visibleReelMatrix, this.evaluatedArea)
        }

        this.totalWays = this.calculateTotalWays(data);
    }

    private calculateTotalWays(data:TheCageGameData) {
        return {
            afterXBomb: 5184,
            start:      5184
        };
    }

    public createWinData(data:TheCageGameData, visibleReelMatrix:StateMatrix<string>, evaluatedArea:StateMatrix<string>):WinData {
        const winLines:WinLineData[] = [];
        const winMatrix = new StateMatrix<TheCageSymbolStates>();
        winMatrix.initWithValueAndMatchDimensionsFromMatrix(TheCageSymbolStates.NO_WIN, visibleReelMatrix.matrix);

        const winRatio = data.totalSpinWinnings / data.playedBetValue;
        const accumulatedWinRatio = data.accumulatedRoundWin / data.playedBetValue;

        let winWays = 0;
        if (isTheCageGameData(data)) {
            for (let win of data.betWayWins) {
                winWays += win.numberOfCombinations;
                let matchingSymbols = [win.symbol, "WB"];

                let skipToNextLine = false;
                /*for(let xWay of this.xWays) {
                    if(xWay.symName == win.symbol) {
                        const allSameSymbolInReel = evaluatedArea.getCoordinatesForValueInColumn(xWay.symbolPostion[0], xWay.symName);
                        if(allSameSymbolInReel.length <= 0) {
                            //There is other same symbols that connect.
                            skipToNextLine = true;
                            break;
                        }
                    }
                }*/

                if (skipToNextLine) {
                    continue;
                }

                const lineMatrix:StateMatrix<boolean> = new StateMatrix();
                lineMatrix.initWithValueAndMatchDimensionsFromMatrix(false, evaluatedArea.matrix);
                const lineData:WinLineData = {
                    betWayWin:win,
                    coordinates:[],
                    matrix:lineMatrix,
                    leftToRight:true,
                }

                lineData.coordinates = evaluatedArea.getAllCoordinatesWhere((value:string, column:number, row:number) => {
                    return matchingSymbols.indexOf(value) >= 0 && column < win.length;
                });

                winMatrix.setValueForCoordinates(lineData.coordinates, TheCageSymbolStates.WIN_TINY);
                lineMatrix.setValueForCoordinates(lineData.coordinates, true);
                winLines.push(lineData);
            }
        }


        return {
            lines:winLines,
            matrix:winMatrix,
            winWays:winWays,
            winRatio:winRatio,
            accumulatedWinRatio:accumulatedWinRatio,
            accumulatedWin:data.accumulatedRoundWin
        }
    }

    public createFreeSpinWinData(data:TheCageGameData, visibleReelMatrix:StateMatrix<string>, evaluatedArea:StateMatrix<string>):WinData {
        const winLines:WinLineData[] = [];
        const winMatrix = new StateMatrix<TheCageSymbolStates>();
        winMatrix.initWithValueAndMatchDimensionsFromMatrix(TheCageSymbolStates.NO_WIN, visibleReelMatrix.matrix);

        const winRatio = data.totalAvalancheRoundWinnings / data.playedBetValue;
        const accumulatedWinRatio = data.totalAvalancheRoundWinnings / data.playedBetValue;

        let winWays = 0;
        if (isTheCageGameData(data)) {
            for (let win of data.betWayWins) {
                winWays += win.numberOfCombinations;
                let matchingSymbols = [win.symbol, "WB", "WS"];
                const isMatchingSymbol = (symbol: string) => matchingSymbols.indexOf(symbol) >= 0

                const lineMatrix:StateMatrix<boolean> = new StateMatrix();
                lineMatrix.initWithValueAndMatchDimensionsFromMatrix(false, evaluatedArea.matrix);
                const lineData:WinLineData = {
                    betWayWin:win,
                    coordinates:[],
                    matrix:lineMatrix,
                    leftToRight:true,
                }

                // if we already have a left to right win of the same symbol as the current one then a right to left
                // win would be interpreted as another left to right of the same symbol
                // to prevent this we doublecheck that we dont already have a win of the same symbol as the current one
                const isLeftToRight = evaluatedArea.matrix[0].some(isMatchingSymbol)
                    && evaluatedArea.matrix[1].some(isMatchingSymbol)
                    && evaluatedArea.matrix[2].some(isMatchingSymbol)
                    && !winLines.some((winLine) => winLine.betWayWin.symbol == win.symbol);

                if (isLeftToRight) {
                    lineData.coordinates = evaluatedArea.getAllCoordinatesWhere((value: string, column: number, row: number) => {
                        return isMatchingSymbol(value) && column < win.length;
                    });
                } else {
                    lineData.coordinates = evaluatedArea.getAllCoordinatesWhere((value: string, column: number, row: number) => {
                        // TODO remove magic 9
                        return isMatchingSymbol(value) && column >= (9 - win.length);
                    });
                    lineData.leftToRight = false;
                }

                winMatrix.setValueForCoordinates(lineData.coordinates, TheCageSymbolStates.WIN_TINY);
                lineMatrix.setValueForCoordinates(lineData.coordinates, true);
                winLines.push(lineData);
            }
        }


        return {
            lines:winLines,
            matrix:winMatrix,
            winWays:winWays,
            winRatio:winRatio,
            accumulatedWinRatio:accumulatedWinRatio,
            accumulatedWin:data.totalAvalancheRoundWinnings
        }
    }

    public static getKillDataFromCollectors():KillBadgeData[] {
        const result:KillBadgeData[] = [];


/*
        //Test data
        let birdListOrg = [
            {
                "originalReel":0,
                "originalRow":1,
                "originalSym":11,
                "currentReel":1,
                "currentRow":1,
                "currentSym":11,
                "symName":"S1",
                "multiplier":1,
                "accumulatedWinAmountTimesBet":109,
                "closeNeighbors":[
                    [
                        0,
                        1
                    ],
                    [
                        0,
                        2
                    ],
                    [
                        2,
                        1
                    ],
                    [
                        2,
                        2
                    ]
                ],
                "hitPoint":2,
                "hitPointBefore":1,
                "isCollector":true,
                "performedCollectorThisSpin":true,
                "isPayer":false,
                "performedPayerThisSpin":false,
                "killHistoryList":[
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":65000,
                        "round":5
                    },
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":65000,
                        "round":5
                    },
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":65000,
                        "round":5
                    },
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":65000,
                        "round":5
                    },


                ]
            },
            {
                "originalReel":2,
                "originalRow":0,
                "originalSym":11,
                "currentReel":3,
                "currentRow":0,
                "currentSym":11,
                "symName":"S1",
                "multiplier":1,
                "accumulatedWinAmountTimesBet":28,
                "closeNeighbors":[
                    [
                        2,
                        0
                    ],
                    [
                        2,
                        1
                    ],
                    [
                        4,
                        0
                    ],
                    [
                        4,
                        1
                    ]
                ],
                "hitPoint":3,
                "hitPointBefore":3,
                "isCollector":false,
                "performedCollectorThisSpin":false,
                "isPayer":false,
                "performedPayerThisSpin":false,
                "killHistoryList":[
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":11,
                        "round":2
                    },
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":2,
                        "round":4
                    },
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":3,
                        "round":7
                    }
                ]
            },
            {
                "originalReel":4,
                "originalRow":0,
                "originalSym":11,
                "currentReel":5,
                "currentRow":0,
                "currentSym":12,
                "symName":"S2",
                "multiplier":1,
                "accumulatedWinAmountTimesBet":41,
                "closeNeighbors":[
                    [
                        4,
                        0
                    ],
                    [
                        6,
                        1
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        2,
                        2
                    ],
                    [
                        3,
                        1
                    ],
                    [
                        4,
                        1
                    ]
                ],
                "hitPoint":1,
                "hitPointBefore":1,
                "isCollector":false,
                "performedCollectorThisSpin":false,
                "isPayer":false,
                "performedPayerThisSpin":false,
                "killHistoryList":[
                    {
                        "sym":11,
                        "symName":"S1",
                        "attribute":"",
                        "amount":1,
                        "round":3
                    }
                ]
            }
        ]
        const cornerList = [
            {
                "reel":0,
                "row":0,
                "locked":true,
                "amountHoldingTimesBet":37,
                "affectedArea":[
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        2,
                        0
                    ]
                ]
            },
            {
                "reel":0,
                "row":3,
                "locked":false,
                "amountHoldingTimesBet":6,
                "affectedArea":[
                    [
                        0,
                        2
                    ],
                    [
                        1,
                        2
                    ],
                    [
                        2,
                        3
                    ]
                ]
            },
            {
                "reel":6,
                "row":0,
                "locked":true,
                "amountHoldingTimesBet":1,
                "affectedArea":[
                    [
                        4,
                        0
                    ],
                    [
                        5,
                        0
                    ],
                    [
                        6,
                        1
                    ]
                ]
            },
            {
                "reel":6,
                "row":3,
                "locked":false,
                "amountHoldingTimesBet":1,
                "affectedArea":[
                    [
                        4,
                        3
                    ],
                    [
                        5,
                        2
                    ],
                    [
                        6,
                        2
                    ]
                ]
            }
        ]
        const numberOfRounds = 3;

        let birdList:any[] = [];
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);
        birdList = birdList.concat(birdListOrg);

*/


        const numberOfRounds = TheCage.model.data.numberOfFreespinsPlayed
        const cornerList = TheCage.model.data.cornerCollectorsList;
        const birdList  = TheCage.model.data.birdCollectorsList;


        for (let birdData of birdList) {
            for (let killData of birdData.killHistoryList) {
                result.push({
                    name:killData.symName,
                    amount:killData.amount,
                    attribute:killData.attribute.toUpperCase(),
                    round:killData.round
                });
            }
        }

        result.sort((a:KillBadgeData, b:KillBadgeData) => {
            return a.round - b.round;
        });

        for (let cornerData of cornerList) {
            if (!cornerData.locked && cornerData.amountHoldingTimesBet > 0) {
                result.push({
                    name:"CORNER",
                    amount:cornerData.amountHoldingTimesBet,
                    attribute:"NONE",
                    round:numberOfRounds
                });
            }
        }

        return result;
    }

    public isBoostedBet():boolean {
        return TheCage.apiPlugin.betHandler.betBoost != undefined;
    }

    public isNearWinAllowed():boolean {
        return !this.hasWonFsClient && !this.data.wasFeatureBuy;
    }

}